// @flow
import appsUtil from './AppsUtil';

class GrowthUtil {
	isProfileRequired() {
		return ((appsUtil.hasFeature('temp_enable_throughline_v1_workflow') || appsUtil.hasFeature('temp_enable_throughline_v3_workflow')) && appsUtil.isPostPurchaseUserForCCPPOrCCPPN())
			|| ((appsUtil.hasFeature('temp_enable_throughline_singlePs') || appsUtil.hasFeature('temp_enable_throughline_v3_workflow')) && appsUtil.isPostPurchaseUserForPhotoshop())
			|| (appsUtil.hasFeature('temp_enable_throughline_v3_workflow') && (appsUtil.isDownloadPage('photoshop') || appsUtil.isDownloadPage('lightroom')));
	}
}

export default new GrowthUtil();
